"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _button = _interopRequireDefault(require("@clayui/button"));

var _form = require("@clayui/form");

var _icon = _interopRequireDefault(require("@clayui/icon"));

var _shared = require("@clayui/shared");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireWildcard(require("react"));

var _DropDownContext = require("./DropDownContext");

var _excluded = ["className", "defaultValue", "formProps", "onChange", "spritemap", "submitProps", "value"],
    _excluded2 = ["className", "onSubmit"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var defaultOnSubmit = function defaultOnSubmit(event) {
  return event.preventDefault();
};

var defaultSubmitProps = {
  'aria-label': 'Search',
  type: 'button'
};

var ClayDropDownSearch = function ClayDropDownSearch(_ref) {
  var className = _ref.className,
      _ref$defaultValue = _ref.defaultValue,
      defaultValue = _ref$defaultValue === void 0 ? '' : _ref$defaultValue,
      _ref$formProps = _ref.formProps,
      formProps = _ref$formProps === void 0 ? {} : _ref$formProps,
      onChange = _ref.onChange,
      spritemap = _ref.spritemap,
      _ref$submitProps = _ref.submitProps,
      submitProps = _ref$submitProps === void 0 ? defaultSubmitProps : _ref$submitProps,
      valueProp = _ref.value,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var formClassName = formProps.className,
      onSubmit = formProps.onSubmit,
      otherFormProps = _objectWithoutProperties(formProps, _excluded2);

  var _useControlledState = (0, _shared.useControlledState)({
    defaultName: 'defaultValue',
    defaultValue: defaultValue,
    handleName: 'onChange',
    name: 'value',
    onChange: onChange,
    value: valueProp
  }),
      _useControlledState2 = _slicedToArray(_useControlledState, 3),
      value = _useControlledState2[0],
      setValue = _useControlledState2[1],
      isUncontrolled = _useControlledState2[2];

  var _useContext = (0, _react.useContext)(_DropDownContext.DropDownContext),
      onSearch = _useContext.onSearch,
      tabFocus = _useContext.tabFocus;

  (0, _react.useEffect)(function () {
    if (isUncontrolled) {
      onSearch(value);
    }
  }, [isUncontrolled, value]);
  return /*#__PURE__*/_react.default.createElement("form", _extends({
    className: (0, _classnames.default)(className, formClassName),
    onSubmit: onSubmit ? onSubmit : defaultOnSubmit
  }, otherFormProps), /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown-section"
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.Group, {
    small: true
  }, /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupItem, null, /*#__PURE__*/_react.default.createElement(_form.ClayInput, _extends({}, otherProps, {
    insetAfter: true,
    onChange: function onChange(event) {
      return setValue(event.target.value);
    },
    tabIndex: !tabFocus ? -1 : undefined,
    type: "text",
    value: value
  })), /*#__PURE__*/_react.default.createElement(_form.ClayInput.GroupInsetItem, {
    after: true,
    tag: "span"
  }, /*#__PURE__*/_react.default.createElement(_button.default, _extends({}, submitProps, {
    displayType: "unstyled",
    tabIndex: !tabFocus ? -1 : undefined
  }), /*#__PURE__*/_react.default.createElement(_icon.default, {
    spritemap: spritemap,
    symbol: "search"
  })))))));
};

var _default = ClayDropDownSearch;
exports.default = _default;